import { useEffect, useRef } from "react";

const WHATSAPP_URL = "https://wa.me/5547996077227?text=Olá,%20gostaria%20de%20falar%20com%20um%20advogado.";

export default function Hero() {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const subtitleRef = useRef<HTMLParagraphElement>(null);
  const ctaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const elements = [titleRef.current, subtitleRef.current, ctaRef.current];
    elements.forEach((el, i) => {
      if (!el) return;
      el.style.opacity = "0";
      el.style.transform = "translateY(30px)";
      setTimeout(() => {
        if (!el) return;
        el.style.transition = "opacity 0.8s ease, transform 0.8s ease";
        el.style.opacity = "1";
        el.style.transform = "translateY(0)";
      }, 300 + i * 200);
    });
  }, []);

  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20modern%20law%20office%20interior%20with%20dark%20blue%20navy%20tones%2C%20sophisticated%20bookshelves%20with%20legal%20volumes%2C%20marble%20desk%2C%20golden%20accents%2C%20soft%20ambient%20lighting%2C%20premium%20minimalist%20architecture%2C%20high-end%20professional%20environment%2C%20deep%20shadows%20and%20rich%20dark%20blue%20atmosphere%2C%20Brazilian%20law%20firm%20aesthetic%2C%20ultra-realistic%20photograph&width=1440&height=900&seq=hero001&orientation=landscape"
          alt="Escritório Quelen Manske Advocacia"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A2472]/90 via-[#0A2472]/80 to-[#1F4ED8]/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A2472]/60 via-transparent to-transparent" />
      </div>

      {/* Decorative gold line */}
      <div
        className="absolute top-0 left-0 w-full h-1"
        style={{ background: "linear-gradient(90deg, #C8A63A, #E6D18A, #C8A63A)" }}
      />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-3 mb-8">
          <div className="w-8 h-px" style={{ background: "linear-gradient(90deg, transparent, #C8A63A)" }} />
          <span
            className="text-xs font-semibold tracking-[0.3em] uppercase"
            style={{ color: "#E6D18A" }}
          >
            Joinville – SC
          </span>
          <div className="w-8 h-px" style={{ background: "linear-gradient(90deg, #C8A63A, transparent)" }} />
        </div>

        {/* Title */}
        <h1
          ref={titleRef}
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 max-w-4xl mx-auto"
          style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: "-0.02em" }}
        >
          Excelência jurídica para proteger o que realmente importa.
        </h1>

        {/* Subtitle */}
        <p
          ref={subtitleRef}
          className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Especialistas em Direito Médico e Direito à Saúde, com atuação completa e estratégica.
        </p>

        {/* CTAs */}
        <div ref={ctaRef} className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-3 px-8 py-4 rounded-md font-semibold text-base text-[#0A2472] transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer whitespace-nowrap"
            style={{ background: "linear-gradient(135deg, #C8A63A, #E6D18A)", fontFamily: "'Inter', sans-serif" }}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl" />
            </span>
            Fale com um advogado
          </a>
          <button
            onClick={() => handleScroll("#areas")}
            className="flex items-center gap-3 px-8 py-4 rounded-md font-semibold text-base text-white border border-white/40 hover:border-white/80 hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Nossas áreas de atuação
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </button>
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-3 gap-8 max-w-2xl mx-auto">
          {[
            { value: "9+", label: "Áreas de atuação" },
            { value: "100%", label: "Compromisso com o cliente" },
            { value: "SC", label: "Joinville e região" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div
                className="text-2xl md:text-3xl font-bold mb-1"
                style={{ color: "#E6D18A", fontFamily: "'Cormorant Garamond', serif" }}
              >
                {stat.value}
              </div>
              <div className="text-xs text-white/60 tracking-wide uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
